import { Icon, Link } from 'prensa'
import React from 'react'

import { IconProps } from './types'

const IcEmail = ({ color, href }: IconProps) => {
  return (
    <Link href={href} aria-label='Logo E-mail' target='_blank' rel='noreferrer' title='E-mail' mr={3}>
      <Icon color={color} width='24' height='24' viewBox='0 0 24 24'>
        <path fillRule="evenodd" clipRule="evenodd" d="M10.3036 10.9548L2.27751 4.0992C1.6899 3.59728 1.33408 2.98221 1.17831 2.33999C1.64062 1.56539 2.3132 0.934707 3.1208 0.5232C4.148 0 5.492 0 8.18 0H16.82C19.508 0 20.852 0 21.8792 0.5232C22.6868 0.934706 23.3594 1.56539 23.8217 2.33999C23.6659 2.98222 23.3101 3.59729 22.7225 4.09921L14.6964 10.9548C13.4314 12.0352 11.5686 12.0352 10.3036 10.9548ZM0.500313 7.02864C0.5 7.23663 0.5 7.45355 0.5 7.68V16.32C0.5 19.008 0.5 20.352 1.0232 21.3792C1.48339 22.2823 2.21766 23.0166 3.1208 23.4768C4.148 24 5.492 24 8.18 24H16.82C19.508 24 20.852 24 21.8792 23.4768C22.7823 23.0166 23.5166 22.2823 23.9768 21.3792C24.5 20.352 24.5 19.008 24.5 16.32V7.68C24.5 7.45355 24.5 7.23664 24.4997 7.02865L16.8928 13.5262C14.3629 15.6871 10.6371 15.6871 8.10724 13.5262L0.500313 7.02864Z" fill="#5C637A" />
      </Icon>
    </Link> 
  )
}

export { IcEmail }

